/**
 * Company model readiness (ISSUE-264 / ISSUE-268).
 * GET /api/v1/companies/{company_id}/model-readiness
 */

import { apiClient } from './apiClient';

export interface CompanyModelReadiness {
  company_id: string;
  company_name?: string;
  model_ready: boolean;
  model_import_present: boolean;
  checks: {
    has_kryspace_slug: boolean;
    kryspace_slug: string | null;
    artifact_item_count: number;
    seed_artifact_item_count?: number;
    company_model_item_count?: number;
    domain_artifact_count: number;
    platform_gates_passed: boolean;
    platform_gate_policy?: string | null;
    platform_validation_status: string | null;
    platform_gates_error?: string;
  };
  blockers: string[];
}

export const companyModelReadinessService = {
  async assess(companyId: string): Promise<CompanyModelReadiness> {
    const response = await apiClient.get<CompanyModelReadiness>(
      `/companies/${companyId}/model-readiness`
    );
    return response.data;
  },
};
